import { jsxs as e, jsx as t } from "react/jsx-runtime";
const s = ({ size: r = 24, ...a }) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: r,
    height: r,
    viewBox: "0 0 32 32",
    fill: "none",
    ...a,
    children: [
      /* @__PURE__ */ t("circle", { cx: "16", cy: "16", r: "16", fill: "#003399" }),
      /* @__PURE__ */ t(
        "path",
        {
          id: "path10",
          d: "m16 5.092-0.0039 0.01562-0.3301 1.102-1.168-0.02539 0.9609 0.6641-0.3867 1.102h2e-3l0.9257-0.7051 0.9297 0.707h2e-3l-0.3867-1.102 0.9609-0.666-1.17 0.02539z",
          fill: "#fc0"
        }
      ),
      /* @__PURE__ */ t("use", { transform: "translate(4.626 1.342)", xlinkHref: "#path10" }),
      /* @__PURE__ */ t("use", { transform: "translate(-4.62 1.35)", xlinkHref: "#path10" }),
      /* @__PURE__ */ t("use", { transform: "translate(-8.141 4.857)", xlinkHref: "#path10" }),
      /* @__PURE__ */ t("use", { transform: "translate(-9.482 9.482)", xlinkHref: "#path10" }),
      /* @__PURE__ */ t("use", { transform: "translate(8.139 4.857)", xlinkHref: "#path10" }),
      /* @__PURE__ */ t("use", { transform: "translate(-8.138 14.36)", xlinkHref: "#path10" }),
      /* @__PURE__ */ t("use", { transform: "translate(9.48 9.482)", xlinkHref: "#path10" }),
      /* @__PURE__ */ t("use", { transform: "translate(-4.709 17.54)", xlinkHref: "#path10" }),
      /* @__PURE__ */ t("use", { transform: "translate(8.135 14.36)", xlinkHref: "#path10" }),
      /* @__PURE__ */ t("use", { transform: "translate(4.707 17.54)", xlinkHref: "#path10" }),
      /* @__PURE__ */ t("use", { transform: "translate(-4.7e-5 18.96)", xlinkHref: "#path10" })
    ]
  }
);
export {
  s as RegionEuropeIcon
};
